import 'css-chunksrc/client/scenes/constrainElement/endStartForm/styles.scss';export default {
  "form": "_form_rko18_1"
};